import moment from 'moment';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Header, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { Campo } from 'src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes';
import { TelefonosProtocolo } from 'src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/tipos';

const DIAS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];

const mapaDeNombresDeBloques: Record<string, string> = {
    MA1: 'Matemática 1',
    MA2: 'Matemática 2',
    LA1: 'Lenguaje 1',
    LA2: 'Lenguaje 2',
    HA1: 'Historia 1',
    HA2: 'Historia 2',
    BA: 'Biología',
    FA: 'Física',
    QA: 'Química',
    MI1: 'Matemática 1',
    MI2: 'Matemática 2',
    LI1: 'Lenguaje 1',
    LI2: 'Lenguaje 2',
    HI1: 'Historia 1',
    HI2: 'Historia 2',
    BI: 'Biología',
    FI: 'Física',
    QI: 'Química',
    MV1: 'Matemática 1',
    MV2: 'Matemática 2',
    LV1: 'Lenguaje 1',
    LV2: 'Lenguaje 2',
    HV1: 'Historia 1',
    HV2: 'Historia 2',
    BV: 'Biología',
    FV: 'Física',
    QV: 'Química',
    BE: 'E. Biología',
    FE: 'E. Física',
    QE: 'E. Química',
};

interface FilaCursoProps {
    asignatura: string;
    dia: string;
    bloqueHorario: { horaInicio: string; horaTermino: string };
    codigo: string;
}
const FilaCurso: React.FunctionComponent<FilaCursoProps> = props => {
    const { asignatura, dia, bloqueHorario, codigo } = props;
    return (
        <Table.Row>
            <Table.Cell>{dia}</Table.Cell>
            <Table.Cell>
                {bloqueHorario.horaInicio} – {bloqueHorario.horaTermino}
            </Table.Cell>
            <Table.Cell>{asignatura}</Table.Cell>
            <Table.Cell>{codigo}</Table.Cell>
        </Table.Row>
    );
};

interface Props {
    nombreAlumno: React.ReactNode;
    cursos: Resultados<'cursosQueElAlumnoPuedeInscribir'>['cursos'];
    informacionDeContacto?: {
        correos: Array<string>;
        telefonos: TelefonosProtocolo;
    };
}

interface State {
    mostrarImprimible: boolean;
}

class Resumen extends React.Component<Props, State> {
    public state: State = {
        mostrarImprimible: false,
    };

    public render() {
        const { nombreAlumno, cursos, informacionDeContacto } = this.props;

        cursos.sort((a, b) => {
            if (a.dia < b.dia) {
                return -1;
            }
            if (a.dia > b.dia) {
                return 1;
            }

            if (a.bloqueHorario < b.bloqueHorario) {
                return -1;
            }
            if (a.bloqueHorario > b.bloqueHorario) {
                return 1;
            }

            return 0;
        });

        return (
            <div>
                <Header as='h1'>Resumen de la inscripción</Header>

                <Header as='h3'>{nombreAlumno}</Header>
                {informacionDeContacto?.correos.map((correo, i) => (
                    <Campo
                        key={`${correo}-${i}`}
                        etiqueta={'Correos'}
                        valor={
                            <a
                                href={`mailto:${correo}?subject=Horario online 2020 Preualameda`}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                {correo}
                            </a>
                        }
                    />
                ))}
                <Campo
                    etiqueta={'Teléfono movil'}
                    valor={`+56 9 ${informacionDeContacto?.telefonos.movil.numero}`}
                />

                {informacionDeContacto?.telefonos.fijo !== '' &&
                    informacionDeContacto?.telefonos.fijo !== undefined && (
                        <Campo
                            etiqueta={'Teléfono fijo'}
                            valor={`+56 9 ${informacionDeContacto?.telefonos.fijo}`}
                        />
                    )}

                {informacionDeContacto?.telefonos.otros !== undefined &&
                    informacionDeContacto?.telefonos.otros.length >= 1 &&
                    informacionDeContacto?.telefonos.otros.map((telefono, i) => (
                        <Campo
                            key={`${telefono}-${i}`}
                            etiqueta={telefono.nombre}
                            valor={`${telefono.codArea} ${telefono.numero}`}
                        />
                    ))}

                <Table celled collapsing>
                    <Table.Header>
                        <Table.Row textAlign='center'>
                            <Table.HeaderCell>Día</Table.HeaderCell>
                            <Table.HeaderCell>Horario</Table.HeaderCell>
                            <Table.HeaderCell>Asignatura</Table.HeaderCell>
                            <Table.HeaderCell>Código</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {cursos.map(curso => (
                            <FilaCurso
                                key={curso.nombre}
                                asignatura={mapaDeNombresDeBloques[curso.nombre.split('-')[0]]}
                                dia={DIAS[curso.dia - 1]}
                                bloqueHorario={curso.bloqueHorario}
                                codigo={curso.nombre}
                            />
                        ))}
                    </Table.Body>
                </Table>

                <Button content='Versión para imprimir' onClick={this.mostrarImprimible} />

                {this.state.mostrarImprimible && (
                    <Imprimible
                        nombreAlumno={nombreAlumno}
                        cursos={cursos}
                        alCerrar={this.ocultarImprimible}
                    />
                )}
            </div>
        );
    }

    private readonly mostrarImprimible = () => {
        this.setState({ mostrarImprimible: true });
    };

    private readonly ocultarImprimible = () => {
        this.setState({ mostrarImprimible: false });
    };
}

export default Resumen;

// TODO: Buscar la forma de cargar el logo
const Imprimible: React.FunctionComponent<Props & { alCerrar(): void }> = props => {
    const { alCerrar, nombreAlumno, cursos } = props;

    return (
        <WindowPortal alCerrar={alCerrar}>
            <style>{`
                @page {
                    size: Letter;
                }
                body {
                    font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
                    font-size: 12px;
                }
                .logo {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                }
                h1 {
                    padding-top: 1cm;
                    text-align: center;
                }
                .fecha {
                    text-align: center;
                }
                .nombre-alumno {
                    margin-top: 1cm;
                    font-size: 14px;
                    font-weight: bold;
                }
                table {
                    margin-top: 1cm;
                    width: 75%;
                    border-collapse: collapse;
                }
                table, th, td {
                    border: 1px solid black;
                    height: 6mm;
                }
                .pie {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    font-size: 11px;
                    text-align: center;
                }
            `}</style>

            <h1>Resumen de inscripción</h1>

            <div className='fecha'>{moment().format('DD/MM/YYYY')}</div>

            <div className='nombre-alumno'>{nombreAlumno}</div>

            <table>
                <tr>
                    <th>Día</th>
                    <th>Horario</th>
                    <th>Asignatura</th>
                    <th>Código</th>
                </tr>
                {cursos.map(curso => (
                    <tr key={curso.nombre}>
                        <td>{DIAS[curso.dia - 1]}</td>
                        <td>
                            {curso.bloqueHorario.horaInicio} – {curso.bloqueHorario.horaTermino}
                        </td>
                        <td>{mapaDeNombresDeBloques[curso.nombre.split('-')[0]]}</td>
                        <td>{curso.nombre}</td>
                    </tr>
                ))}
            </table>

            <div className='pie'>
                <hr />
                <div>Almirante Barroso #156, Santiago de Chile</div>
                <div>Teléfono: 22 688 0180 – WhatsApp: +569 6271 0508</div>
                <div>www.redalameda.cl</div>
            </div>
        </WindowPortal>
    );
};

class WindowPortal extends React.PureComponent<{ alCerrar(): void }> {
    private readonly element = document.createElement('div');
    private externalWindow: Window | null = null;

    public componentWillMount() {
        this.externalWindow = window.open();
        this.externalWindow!.document.body.appendChild(this.element);
        this.externalWindow!.addEventListener('beforeunload', () => {
            this.props.alCerrar();
        });
    }

    public componentWillUnmount() {
        this.externalWindow!.close();
    }

    public render() {
        return ReactDOM.createPortal(this.props.children, this.element);
    }
}



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/Inscribir/Resumen/index.tsx